import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { environment } from 'src/environments/environment';
import * as L from 'leaflet'
import { isEmptyObject } from 'jquery';
import { ALERT_COLOR_MAPPING, FORMAT_VS_SOURCEMAPPING, LOCATION_HIE } from './fog-map/fog-map-constants';

@Injectable({
  providedIn: 'root'
})
export class FogDashboardService {
  combinedTimeStampList: any;
  mandalData: Object;
  urlConst: any = environment.url.HEATWAVE_STAGING_API_URL

  constructor(private http: HttpClient, private utils: UtilsService, private datePipe: DatePipe) { }
  getDistrictData(postData) {
    let url: any;
    url = this.urlConst + 'heatWatches/getHeatWatchesData';
    return this.http.post<any>(url, postData);
  }
  getHeirarchy(postData) {
    let url = this.urlConst + "locations/heirarchy";
    return this.http.post<any>(url, postData)
  }
  getFogCategoryBlockDataCount(postData) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + 'fog/getVisibilityData'
    return this.http.post<any>(url, postData)
  }
  getFogCategoryBlockNowcastDataCount(postData) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + 'nowcast/getEUMETSATFogData'
    return this.http.post<any>(url, postData)
  }
  getHeapMapsForFogForecast(source) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + 'fog/getVisibilityHeatMaps/' + source
    return this.http.get<any>(url)
  }
  getHeapMapsForFogNowcast() {
    let url = environment.url.HEATWAVE_STAGING_API_URL + 'nowcast/getHeatMapData/NOWCAST/EUMETSAT_FOG_NOWCAST'
    return this.http.get<any>(url)
  }
  getFogCategoryDataCount(postData: any) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + 'fog/getFogCategoryDataCount';
    return this.http.post<any>(url, postData);
  }
  getFogCategoryNowcastDataCount(postData: any) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + 'nowcast/getEUMETSATFogCategoryDataCount';
    return this.http.post<any>(url, postData);
  }
  getSectorWiseFogAlertData(postData: any, endpoint:any) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + endpoint;
    return this.http.post<any>(url, postData);
  }
  getCurrentDateInYYYYMMDDFormat1() {
    const currentDate = new Date();
    const threeDaysAgo = new Date(currentDate);
    threeDaysAgo.setDate(currentDate.getDate() - 3); // Set date to three days ago

    const year = threeDaysAgo.getFullYear();
    const month = String(threeDaysAgo.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(threeDaysAgo.getDate()).padStart(2, '0');

    const formattedDate = `${year}${month}${day}`;
    return formattedDate;
  }
  convertMillisToYYYYMMDD(timestamp: number): string {
    const date = new Date(Number(timestamp));

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}${month}${day}`;
  }
  createLabels(tsList) {
    const labelStrings = [];
    let device = this.utils.getDeviceType()
    let labels
    for (const ts of tsList) {
      if (device == 'mobile') {
        labels = this.utils.convertModelDatetoDateForMobile(ts)
        labels = this.datePipe.transform(labels, "dd/MM")
      }
      else if (device == 'desktop') {
        labels = this.utils.convertModelDatetoDate(ts).toLocaleDateString()
      }
      labelStrings.push({
        groupName: ts,
        label: {
          label: labels,
          toolTip: '5:30 AM - 5:30 AM'
        },
        fullLabel: labels
      });
    }
    return labelStrings;
  }
  convertTimestampToFullBlockValue(ts) {
    ts = Number(ts);
    let starthours = new Date(ts).getHours();
    const startminutes = new Date(ts).getMinutes();
    let startamPm = 'A.M';
    if (starthours > 12) {
      starthours = starthours - 12;
      startamPm = 'P.M';
    }
    let endhours = new Date(ts + ProjConstants.MILLS_IN_10MINS).getHours();
    const endminutes = new Date(ts + ProjConstants.MILLS_IN_10MINS).getMinutes();
    let endamPm = 'A.M';
    if (endhours > 12) {
      endhours = endhours - 12;
      endamPm = 'P.M';
    }
    return starthours.toString().padStart(2, '0') + ':' + startminutes.toString().padStart(2, '0') + ' ' + startamPm + ' - ' + endhours.toString().padStart(2, '0') + ':' + endminutes.toString().padStart(2, '0') + ' ' + endamPm;
  }
  convertTimestampToBlockValue(ts) {
    ts = Number(ts);
    const date = new Date(ts);

    // Date parts
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    let hours = date.getHours();     // Local time hours
    const minutes = date.getMinutes();

    let amPm = hours >= 12 ? "P.M" : "A.M";

    // Convert to 12-hour format
    hours = hours % 12;
    if (hours === 0) hours = 12;

    // Format with leading zeros
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${day}/${month}/${year} ${formattedHours}:${formattedMinutes} ${amPm}`;
  }
  convertTimestampToDateBlockValue(ts: any, params: any, type:any) {
    ts = Number(ts);
    const date = new Date(ts);

    // Date parts
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    // Time parts
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const amPm = hours >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format
    hours = hours % 12;
    if (hours === 0) hours = 12;

    if (params.fogView == 'observed') {
      return `${hours}:${minutes} ${amPm}`
    } else if (params.fogView == 'forecast' && params.format == 'HOURLY') {
      return `${day}/${month}/${year} ${hours}:${minutes} ${amPm} (${type})`
    } else if (params.fogView == 'forecast' && params.format == 'DAILY') {
      return `${day}/${month}/${year}`
    }
  }

  getImageBounds(imageBounds) {
    const anchors = [];
    anchors.push([imageBounds[1][0], imageBounds[0][1]]);
    anchors.push([imageBounds[1][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[0][1]]);
    return anchors;
  }
  getHeatMapImageBounds(heatmapimageBounds: any) {
    let latlongs: any = [];
    let imageBounds: any = []

    latlongs.push(heatmapimageBounds['southWest']['latitude']);
    latlongs.push(heatmapimageBounds['southWest']['longitude']);
    imageBounds.push(latlongs);
    latlongs = [];
    latlongs.push(heatmapimageBounds['northEast']['latitude']);
    latlongs.push(heatmapimageBounds['northEast']['longitude']);
    imageBounds.push(latlongs);
    return imageBounds;
  }

  public getFeatureInfo(latlng: any, layer: any, map: any) {
    let url = this.getFeatureInfoUrl(latlng, layer, map);
    return this.http.get(url).pipe(
      catchError((err) => {
        return EMPTY;
      })
    );
  }
  public getFeatureInfoUrl(latlng: any, layer: any, map: any) {
    // if(!isNullOrUndefined(latlng.latlng)){
    //   latlng = latlng.latlng
    // }
    let point = map.latLngToContainerPoint(latlng, map.getZoom());
    let size = map.getSize();
    let params: any = {
      request: 'getFeatureInfo',
      service: 'WMS',
      srs: 'EPSG:4326',
      transparent: true,
      version: layer ? layer.wmsParams.version : '',
      format: layer ? layer.wmsParams.format : '',
      bbox: map.getBounds().toBBoxString(),
      height: Math.floor(size.y),
      width: Math.floor(size.x),
      layers: layer ? layer.wmsParams.layers : '',//queryLayers.join(','),
      query_layers: layer ? layer.wmsParams.layers : '',//queryLayers.join(','),
      info_format: 'application/json',
      feature_count: 50,
      VIEWPARAMS: layer ? (layer.wmsParams.VIEWPARAMS ? layer.wmsParams.VIEWPARAMS : '1=1') : ''
      // CQL_FILTER: layer ? (layer.wmsParams.cql_filter ? layer.wmsParams.cql_filter : '1=1') : ''
    };
    params[params.version === '1.3.0' ? 'i' : 'x'] = Math.floor(point.x);
    params[params.version === '1.3.0' ? 'j' : 'y'] = Math.floor(point.y);
    let url = layer._url + (L as any).Util.getParamString(params, layer._url, true);
    return url;
  }
  mergeResponses(response1: any, response2: any): any {
    const merged = { ...response1 };

    if (!isEmptyObject(merged) && !isEmptyObject(response2)) {
      Object.keys(response2).forEach((uuid) => {
        // If UUID does not exist in response1, copy entire object
        if (!merged[uuid]) {
          merged[uuid] = response2[uuid];
          return;
        }

        const data1 = merged[uuid].data || {};
        const data2 = response2[uuid].data || {};

        // Merge date-wise data
        merged[uuid].data = {
          ...data1,
          ...data2
        };
      });
      return merged;
    } else if (!isEmptyObject(merged)) {
      return merged
    } else {
      return response2
    }
  }
  getPostDataForFogForecast(params, infoComp, type) {
    let hie = LOCATION_HIE;
    infoComp.selectedLocType = params['locType'];
    let pUUID = params['pUUID'];
    let cType = hie[hie.indexOf(infoComp.selectedLocType) + 1];
    let src: any;
    if (type == 'observed') {
      src = 'EUMETSAT_FOG_NOWCAST'
    } else {
      src = FORMAT_VS_SOURCEMAPPING[params['format']][params['source']]
    }
    return {
      pUuid: pUUID,
      pType: infoComp.selectedLocType,
      cType: cType,
      dataLocType: hie[hie.indexOf(cType) + 1],
      source: src
    };
  }
  getPostDataForFogNowcast(params, infoComp, type) {
    let hie = LOCATION_HIE;
    infoComp.selectedLocType = params['locType'];
    let pUUID = params['pUUID'];
    let pType = hie[hie.indexOf(infoComp.selectedLocType) + 1];
    let cType = hie[hie.indexOf(pType) + 1];
    let src: any;
    if (type == 'observed') {
      src = 'EUMETSAT_FOG_NOWCAST'
    } else {
      src = FORMAT_VS_SOURCEMAPPING[params['format']][params['source']]
    }
    return {
      pUuid: pUUID,
      pType: pType,
      cType: cType,
      dataLocType: cType,
      source: src,
      hoursCount: this.getHoursCount()
    };
  }
  filterTodayTimestamps(timestamps: Array<string | number>): number[] {

    const now = new Date();
    const todayStart = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    ).getTime();

    return (timestamps as Array<string | number>)
      .map((ts: string | number) => Number(ts))
      .filter((ts: number) => ts >= todayStart);
  }
  getFogAlertPieChart(seriesData) {
      let options: object = {
        chart: {
        type: 'pie',
        zooming: {
            type: 'xy'
        },
        panning: {
            enabled: true,
            type: 'xy'
        },
        panKey: 'shift'
    },
    title: {
        text: 'Distribution by Category',
        style: {
        color: '#000',
        fontSize: '18px',
        fontWeight: 'bold'
      }
    },
    plotOptions: {
        pie: {
            innerSize: '60%',
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: [{
                enabled: true,
                distance: 20
            }, {
                enabled: true,
                distance: -40,
                format: '{point.percentage:.1f}%',
                style: {
                    fontSize: '1.2em',
                    textOutline: 'none',
                    opacity: 0.7
                },
                filter: {
                    operator: '>',
                    property: 'percentage',
                    value: 10
                }
            }]
        }
    },
    credits: {
      enabled: false
    },
    series: [
        {
            name: 'Count',
            colorByPoint: true,
            data: seriesData
        }
    ]
      }
      return options
  }

  formatFogAlertData(input: any): any {
    const result: any = {};

    Object.keys(input).forEach((uuid) => {
      const timeData =
        input[uuid] && input[uuid].data ? input[uuid].data : {};

      result[uuid] = {};

      Object.keys(timeData).forEach((timestamp) => {
        result[uuid][timestamp] = timeData[timestamp].fc;
      });
    });

    return result;
  }
  formatYYYYMMDD(dateNum: number | string): string {
  const str = dateNum.toString();

  const year = Number(str.substring(0, 4));
  const month = Number(str.substring(4, 6)) - 1; // JS months are 0-based
  const day = Number(str.substring(6, 8));

  const date = new Date(year, month, day);

  const months = ['January', 'February', 'March', 'April', 'May', 'June',
                  'July', 'August', 'September', 'October', 'November', 'December'];

  return `${day} ${months[date.getMonth()]} ${year}`;
  }
  getFogSummaryByTimestamp(
    input: any,
    timestamp: any
  ) {
    const categoryCount = {
      Normal: 0,
      Dense: 0,
      'Very Dense': 0,
      Moderate: 0,
      Shallow: 0
    };

    let count = 0;

    Object.keys(input).forEach(uuid => {

      if (!input[uuid] || !input[uuid].data || !input[uuid].data[timestamp]) {
        return;
      }

      count++;

      const category = input[uuid].data[timestamp].fc;

      if (categoryCount.hasOwnProperty(category)) {
        categoryCount[category]++;
      }
    });

    const totalAffected =
      categoryCount.Dense +
      categoryCount['Very Dense'] +
      categoryCount.Moderate +
      categoryCount.Shallow;

    const severeAffected =
      categoryCount.Dense +
      categoryCount['Very Dense'];

    return {
      count,
      categoryCount,
      totalAffected,
      severeAffected
    };
  }
  getAviationFogSummaryByTimestamp(input: any, timestamp: any) {
  const result = {
    count: 0,
    categoryCount: {
      Normal: 0,
      Dense: 0,
      'Very Dense': 0,
      Moderate: 0,
      Shallow: 0
    },
    totalAffected: 0,
    severeAffected: 0
  };

  if (!input || !input.data || !input.data[timestamp]) {
    return result;
  }

  const categoryData = input.data[timestamp];

  Object.keys(categoryData).forEach((category) => {
    const value = categoryData[category] || 0;

    result.count += value;

    if (result.categoryCount.hasOwnProperty(category)) {
      result.categoryCount[category] += value;
    }
  });

  // total affected = all except Normal
  result.totalAffected =
    result.categoryCount.Dense +
    result.categoryCount['Very Dense'] +
    result.categoryCount.Moderate +
    result.categoryCount.Shallow;

  // severe affected = Dense + Very Dense
  result.severeAffected =
    result.categoryCount.Dense +
    result.categoryCount['Very Dense'];

  return result;
}
  convertToPieSeries(response: any) {
    const order = ['Very Dense', 'Dense', 'Moderate', 'Shallow', 'Normal'];
    const categoryCount = response && response.categoryCount
      ? response.categoryCount
      : {};

    return order.map((category: string) => {
      return {
        name: category,
        y: categoryCount[category] ? categoryCount[category] : 0,
        color: ALERT_COLOR_MAPPING[category]
      };
    });
  }

  getCurrentDayInfo() {
    const now = new Date();

    const currentMillis = now.getTime();

    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');

    return {
      currentMillis,
      yyyymmdd: `${yyyy}${mm}${dd}`
    };
  }
  getFogLegendHtml() {
    const itemsHtml = Object.keys(ALERT_COLOR_MAPPING)
      .map(category => `
      <div class="d-flex align-items-center mb-1">
        <span class="legend-dot" style="background:${ALERT_COLOR_MAPPING[category]};"></span>
        <span class="ms-2">${category}</span>
      </div>
    `)
      .join('');

    return `
  <div class="fog-legend p-2" style="
      background: white;
      border-radius: 8px;
      box-shadow: 0 2px 6px rgba(0,0,0,0.15);
      width: 40px;
      font-size: 13px;
  ">
    <div class="fw-semibold mb-2">Fog Severity</div>
    ${itemsHtml}
  </div>
  `;
  }

  getHoursCount() {
    const now = new Date();
    return now.getHours() + 1;
  }
}
